import React, { useState, useEffect } from 'react';
import AgentConfigService from '../services/AgentConfigService';

const STORAGE_KEY = 'env_version_info';

/**
 * EnvVersionLabel - Displays environment and version info
 * Checks localStorage first, then fetches from backend if not cached
 * 
 * @param {Object} props
 * @param {Object} props.style - Custom styles to apply
 */
const EnvVersionLabel = ({ style = {} }) => {
  const [envVersion, setEnvVersion] = useState('');

  useEffect(() => {
    const fetchEnvVersion = async () => {
      // Check localStorage first
      const cached = localStorage.getItem(STORAGE_KEY);
      if (cached) {
        setEnvVersion(cached);
        return;
      }

      // Fetch from backend if not in localStorage
      try {
        const mainApiUrl = await AgentConfigService.getMainApiUrl();
        const response = await fetch(`${mainApiUrl}/get_env_version_info`);
        
        if (response.ok) {
          const data = await response.json();
          const version = data.env_version || '';
          
          if (version) {
            // Store in localStorage for future use
            localStorage.setItem(STORAGE_KEY, version);
            setEnvVersion(version);
          }
        }
      } catch (error) {
        console.warn('Failed to fetch env version info:', error);
        // Silently fail - don't render anything
      }
    };

    fetchEnvVersion();
  }, []);

  // Don't render if no version info
  if (!envVersion) {
    return null;
  }

  return (
    <div style={{
      fontSize: '10px',
      color: '#999',
      ...style
    }}>
      {envVersion}
    </div>
  );
};

export default EnvVersionLabel;